import React, { useEffect, useState } from "react";
import { Award } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Badge, statusTone } from "@/components/common";

export default function Results() {
  const [results, setResults] = useState([]);
  useEffect(() => { api.get("/my/results").then(({ data }) => setResults(data)); }, []);
  return (
    <div data-testid="results-page">
      <PageHeader title="Test Results" subtitle="Your performance history" />
      {results.length === 0 ? <EmptyState icon={Award} title="No results yet" subtitle="Take a test to see your performance here." /> : (
        <div className="bg-white border border-border rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-muted text-left text-muted-foreground">
              <tr><th className="p-4">Test</th><th className="p-4">Score</th><th className="p-4">%</th><th className="p-4">Result</th><th className="p-4">Status</th></tr>
            </thead>
            <tbody>
              {results.map((r) => (
                <tr key={r.id} className="border-t border-border" data-testid={`result-${r.id}`}>
                  <td className="p-4 font-medium text-navy">{r.test_title}</td>
                  <td className="p-4">{r.score}/{r.total}</td>
                  <td className="p-4 font-bold">{r.percentage}%</td>
                  <td className="p-4"><Badge tone={r.passed ? "green" : "crimson"}>{r.passed ? "Passed" : "Failed"}</Badge></td>
                  <td className="p-4"><Badge tone={statusTone(r.status)}>{r.status.replace("_", " ")}</Badge></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
